@if (petInfo && petInsuranceView) {
  <div class="top">
    <div class="part left-part">
      <div class="card-title">
        <p class="tag-12">{{ 'insurance-card.title' | translate }}</p>
      </div>
      <div class="main-info block">
        <div class="row">
          <div class="title">
            <p class="body-12">{{ 'insurance-card.name' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-12">{{ petInfo.pet_name }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-12">{{ 'insurance-card.owner' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-12">{{ petInfo.firstname }} {{ petInfo.lastname }}</p>
          </div>
        </div>
        <div class="row">
          <div class="title">
            <p class="body-12">{{ 'insurance-card.insurance-number' | translate }}</p>
          </div>
          <div class="value">
            <p class="subtitle-12">{{ petInfo.contract_number }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part right-part">
      <div class="header"
        [ngClass]="{'active': petInfo.contractStatus === 'active', 'expired' : petInfo.contractStatus === 'expired', 'future': petInfo.contractStatus === 'future'}">
        <div class="status-container">
          <div class="status">
            @if (petInfo.contractStatus === 'active') {
              <p class="tag-12">{{ 'pet-card.status-active-state' | translate }}</p>
            }
            @if (petInfo.contractStatus === 'expired') {
              <p class="tag-12">{{ 'pet-card.status-expired-state' | translate }}</p>
            }
            @if (petInfo.contractStatus === 'future') {
              <p class="tag-12">{{ 'pet-card.status-future-state' | translate }}</p>
            }
          </div>
        </div>
      </div>
      <div class="image">
        <img class="pet-img" [src]="petInsuranceView.image" alt="" width="110" height="110"/>
        <div class="edit-overlay" (click)="$event.stopPropagation(); navigateEditPet()"><img src="assets/edit_pencil_fill.svg" alt="edit"></div>
      </div>
    </div>
  </div>
  <div class="bottom block">
    <div class="row">
      <div class="title">
        <p class="body-12">{{ 'insurance-card.date-of-birth' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-12">{{ petInfo.birthdate | date:'dd.MM.yyyy' }}</p>
      </div>
    </div>
    <div class="row">
      <div class="title">
        <p class="body-12">{{ 'insurance-card.breed' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-12">{{ petInfo.breed | breedTranslate }}</p>
      </div>
    </div>
    <div class="row">
      <div class="title">
        <p class="body-12">{{ 'insurance-card.gender' | translate }}</p>
      </div>
      <div class="value">
        <p class="subtitle-12">{{ petInfo.pet_gender | genderTranslate }}</p>
      </div>
    </div>
  </div>
}
